/* Abstract SVG illustrations for the Process section, amplified */

export const AuditIllustration = () => (
  <svg viewBox="0 0 440 380" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
    {/* Background */}
    <rect x="20" y="20" width="400" height="340" rx="24" fill="#F8FAFC"/>
    {/* Grid lines */}
    {[80, 140, 200, 260, 320].map(y => (
      <line key={y} x1="50" y1={y} x2="390" y2={y} stroke="#E2E8F0" strokeWidth="0.5"/>
    ))}
    {/* Magnifying glass */}
    <circle cx="180" cy="180" r="72" stroke="#0064E0" strokeWidth="3" fill="white" fillOpacity="0.8"/>
    <line x1="232" y1="232" x2="290" y2="290" stroke="#0064E0" strokeWidth="5" strokeLinecap="round"/>
    {/* Data rows inside glass */}
    <rect x="135" y="152" width="55" height="6" rx="3" fill="#0064E0" opacity="0.7"/>
    <rect x="135" y="168" width="75" height="6" rx="3" fill="#0064E0" opacity="0.4"/>
    <rect x="135" y="184" width="45" height="6" rx="3" fill="#0064E0" opacity="0.7"/>
    <rect x="135" y="200" width="65" height="6" rx="3" fill="#0064E0" opacity="0.3"/>
    {/* Priority dots */}
    <circle cx="152" cy="155" r="3" fill="#0064E0"/>
    <circle cx="152" cy="187" r="3" fill="#0064E0"/>
    {/* Checklist items on the right */}
    <rect x="300" y="100" width="80" height="10" rx="4" fill="#0064E0" opacity="0.2"/>
    <rect x="300" y="125" width="65" height="10" rx="4" fill="#0064E0" opacity="0.15"/>
    <rect x="300" y="150" width="75" height="10" rx="4" fill="#0064E0" opacity="0.2"/>
    <rect x="300" y="175" width="55" height="10" rx="4" fill="#0064E0" opacity="0.1"/>
    {/* Check marks */}
    <circle cx="285" cy="105" r="7" fill="#0064E0" opacity="0.15"/>
    <circle cx="285" cy="130" r="7" fill="#0064E0" opacity="0.15"/>
    <circle cx="285" cy="155" r="7" fill="#0064E0" opacity="0.15"/>
    {/* Floating elements */}
    <circle cx="80" cy="70" r="8" fill="#E5F0FF"/>
    <circle cx="380" cy="60" r="12" fill="#E5F0FF"/>
    <circle cx="60" cy="300" r="6" fill="#0064E0" opacity="0.1"/>
    <rect x="350" y="280" width="40" height="40" rx="10" fill="#E5F0FF" opacity="0.6"/>
  </svg>
);

export const MediaBuyingIllustration = () => (
  <svg viewBox="0 0 440 380" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
    {/* Background */}
    <rect x="20" y="20" width="400" height="340" rx="24" fill="#F8FAFC"/>
    {/* Chart baseline */}
    <line x1="60" y1="300" x2="400" y2="300" stroke="#E2E8F0" strokeWidth="1"/>
    {/* Bars with gradient effect */}
    <rect x="80" y="220" width="44" height="80" rx="6" fill="#0064E0" opacity="0.15"/>
    <rect x="144" y="180" width="44" height="120" rx="6" fill="#0064E0" opacity="0.25"/>
    <rect x="208" y="140" width="44" height="160" rx="6" fill="#0064E0" opacity="0.45"/>
    <rect x="272" y="100" width="44" height="200" rx="6" fill="#0064E0" opacity="0.65"/>
    <rect x="336" y="70" width="44" height="230" rx="6" fill="#0064E0" opacity="0.9"/>
    {/* Trend line */}
    <path d="M102 215 L166 175 L230 135 L294 95 L358 65" stroke="#0F172A" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
    {/* Data points */}
    <circle cx="102" cy="215" r="6" fill="white" stroke="#0F172A" strokeWidth="2"/>
    <circle cx="166" cy="175" r="6" fill="white" stroke="#0F172A" strokeWidth="2"/>
    <circle cx="230" cy="135" r="6" fill="white" stroke="#0F172A" strokeWidth="2"/>
    <circle cx="294" cy="95" r="6" fill="white" stroke="#0F172A" strokeWidth="2"/>
    <circle cx="358" cy="65" r="6" fill="white" stroke="#0F172A" strokeWidth="2"/>
    {/* Arrow at top right */}
    <path d="M348 58 L362 50" stroke="#0F172A" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M355 48 L362 50 L358 57" stroke="#0F172A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Platform labels */}
    <rect x="77" y="312" width="50" height="20" rx="6" fill="#E5F0FF"/>
    <rect x="141" y="312" width="50" height="20" rx="6" fill="#E5F0FF"/>
    <rect x="205" y="312" width="50" height="20" rx="6" fill="#E5F0FF"/>
    <rect x="269" y="312" width="50" height="20" rx="6" fill="#E5F0FF"/>
    <rect x="333" y="312" width="50" height="20" rx="6" fill="#E5F0FF"/>
    {/* Floating decorative */}
    <circle cx="50" cy="50" r="10" fill="#E5F0FF"/>
    <rect x="380" y="40" width="30" height="30" rx="8" fill="#E5F0FF" opacity="0.5"/>
  </svg>
);

export const FunnelIllustration = () => (
  <svg viewBox="0 0 440 380" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
    {/* Background */}
    <rect x="20" y="20" width="400" height="340" rx="24" fill="#F8FAFC"/>
    {/* Funnel shape with stages */}
    <path d="M100 60 L340 60 L300 140 L290 200 L260 280 L240 320 L200 320 L180 280 L150 200 L140 140 Z" fill="#E5F0FF" opacity="0.6"/>
    <path d="M100 60 L340 60 L300 140 L290 200 L260 280 L240 320 L200 320 L180 280 L150 200 L140 140 Z" stroke="#0064E0" strokeWidth="2" fill="none" strokeLinejoin="round"/>
    {/* Stage dividers */}
    <line x1="135" y1="120" x2="305" y2="120" stroke="#0064E0" strokeWidth="1" opacity="0.3"/>
    <line x1="148" y1="180" x2="292" y2="180" stroke="#0064E0" strokeWidth="1" opacity="0.3"/>
    <line x1="170" y1="240" x2="270" y2="240" stroke="#0064E0" strokeWidth="1" opacity="0.3"/>
    {/* Stage labels */}
    <rect x="180" y="78" width="80" height="8" rx="4" fill="#0064E0" opacity="0.3"/>
    <rect x="185" y="142" width="70" height="8" rx="4" fill="#0064E0" opacity="0.4"/>
    <rect x="190" y="202" width="60" height="8" rx="4" fill="#0064E0" opacity="0.5"/>
    <rect x="196" y="260" width="48" height="8" rx="4" fill="#0064E0" opacity="0.7"/>
    {/* Flow arrows */}
    <path d="M220 92 L220 108" stroke="#0064E0" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
    <path d="M217 104 L220 108 L223 104" stroke="#0064E0" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <path d="M220 155 L220 168" stroke="#0064E0" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
    <path d="M217 164 L220 168 L223 164" stroke="#0064E0" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    <path d="M220 215 L220 228" stroke="#0064E0" strokeWidth="2" strokeLinecap="round" opacity="0.5"/>
    <path d="M217 224 L220 228 L223 224" stroke="#0064E0" strokeWidth="1.5" strokeLinecap="round" opacity="0.5"/>
    {/* Conversion icon at bottom */}
    <circle cx="220" cy="340" r="12" fill="#0064E0"/>
    <path d="M215 340 L218 343 L225 336" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Side metrics */}
    <rect x="355" y="70" width="60" height="30" rx="8" fill="white" stroke="#E2E8F0" strokeWidth="1"/>
    <rect x="365" y="80" width="30" height="5" rx="2" fill="#0064E0" opacity="0.5"/>
    <rect x="355" y="150" width="60" height="30" rx="8" fill="white" stroke="#E2E8F0" strokeWidth="1"/>
    <rect x="365" y="160" width="25" height="5" rx="2" fill="#0064E0" opacity="0.4"/>
    <rect x="355" y="230" width="60" height="30" rx="8" fill="white" stroke="#E2E8F0" strokeWidth="1"/>
    <rect x="365" y="240" width="35" height="5" rx="2" fill="#0064E0" opacity="0.7"/>
  </svg>
);

export const TestingIllustration = () => (
  <svg viewBox="0 0 440 380" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
    {/* Background */}
    <rect x="20" y="20" width="400" height="340" rx="24" fill="#F8FAFC"/>
    {/* A/B Split line */}
    <line x1="220" y1="50" x2="220" y2="310" stroke="#0064E0" strokeWidth="2" strokeDasharray="8 6" opacity="0.25"/>
    {/* Variant A card */}
    <rect x="45" y="65" width="155" height="210" rx="16" fill="white" stroke="#E2E8F0" strokeWidth="1.5"/>
    <text x="110" y="55" fontSize="16" fontWeight="700" fill="#0064E0" textAnchor="middle" fontFamily="Inter, sans-serif">A</text>
    <rect x="65" y="90" width="115" height="8" rx="4" fill="#0064E0" opacity="0.25"/>
    <rect x="65" y="110" width="90" height="6" rx="3" fill="#0064E0" opacity="0.15"/>
    <rect x="65" y="135" width="115" height="50" rx="8" fill="#E5F0FF"/>
    <rect x="65" y="200" width="70" height="8" rx="4" fill="#0064E0" opacity="0.2"/>
    <rect x="65" y="220" width="115" height="32" rx="8" fill="#0064E0" opacity="0.15"/>
    {/* Variant B card */}
    <rect x="240" y="65" width="155" height="210" rx="16" fill="white" stroke="#B3D4FF" strokeWidth="2"/>
    <text x="310" y="55" fontSize="16" fontWeight="700" fill="#0064E0" textAnchor="middle" fontFamily="Inter, sans-serif">B</text>
    <rect x="260" y="90" width="115" height="8" rx="4" fill="#0064E0" opacity="0.3"/>
    <rect x="260" y="110" width="80" height="6" rx="3" fill="#0064E0" opacity="0.2"/>
    <rect x="260" y="135" width="115" height="50" rx="8" fill="#0064E0" opacity="0.12"/>
    <rect x="260" y="200" width="85" height="8" rx="4" fill="#0064E0" opacity="0.3"/>
    <rect x="260" y="220" width="115" height="32" rx="8" fill="#0064E0" opacity="0.35"/>
    {/* Winner badge on B */}
    <circle cx="400" cy="68" r="16" fill="#0064E0"/>
    <path d="M393 68 L397 72 L407 62" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Metrics comparison bar at bottom */}
    <rect x="45" y="300" width="155" height="40" rx="10" fill="#F8FAFC" stroke="#E2E8F0" strokeWidth="1"/>
    <rect x="65" y="314" width="50" height="12" rx="4" fill="#0064E0" opacity="0.2"/>
    <rect x="240" y="300" width="155" height="40" rx="10" fill="#E5F0FF" stroke="#B3D4FF" strokeWidth="1"/>
    <rect x="260" y="314" width="80" height="12" rx="4" fill="#0064E0" opacity="0.5"/>
    {/* Iteration arrow */}
    <path d="M120 355 C120 370 320 370 320 355" stroke="#0064E0" strokeWidth="2" fill="none" strokeLinecap="round" opacity="0.35"/>
    <path d="M316 359 L320 355 L324 359" stroke="#0064E0" strokeWidth="2" strokeLinecap="round" opacity="0.35"/>
  </svg>
);

export const ReportingIllustration = () => (
  <svg viewBox="0 0 440 380" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-auto">
    {/* Background */}
    <rect x="20" y="20" width="400" height="340" rx="24" fill="#F8FAFC"/>
    {/* Document */}
    <rect x="80" y="40" width="200" height="280" rx="12" fill="white" stroke="#E2E8F0" strokeWidth="1.5"/>
    {/* Header */}
    <rect x="100" y="60" width="100" height="10" rx="5" fill="#0F172A" opacity="0.6"/>
    <rect x="100" y="78" width="60" height="6" rx="3" fill="#475569" opacity="0.3"/>
    {/* Divider */}
    <line x1="100" y1="98" x2="260" y2="98" stroke="#E2E8F0" strokeWidth="1.5"/>
    {/* Metric rows */}
    {[115, 140, 165, 190, 215].map((y, i) => (
      <g key={y}>
        <rect x="100" y={y} width={50 + (i % 3) * 10} height="6" rx="3" fill="#475569" opacity="0.25"/>
        <rect x={220 - (i % 2) * 15} y={y} width={25 + (i % 3) * 8} height="6" rx="3" fill="#0064E0" opacity={0.4 + i * 0.12}/>
      </g>
    ))}
    {/* Divider */}
    <line x1="100" y1="240" x2="260" y2="240" stroke="#E2E8F0" strokeWidth="1.5"/>
    {/* Summary section */}
    <rect x="100" y="255" width="130" height="8" rx="4" fill="#0F172A" opacity="0.4"/>
    <rect x="100" y="275" width="90" height="6" rx="3" fill="#0F172A" opacity="0.2"/>
    <rect x="100" y="293" width="110" height="6" rx="3" fill="#0F172A" opacity="0.15"/>
    {/* Status badge */}
    <rect x="205" y="250" width="55" height="24" rx="12" fill="#E5F0FF"/>
    <path d="M220 262 L224 266 L234 256" stroke="#0064E0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    {/* Side dashboard card */}
    <rect x="300" y="80" width="120" height="100" rx="12" fill="white" stroke="#E2E8F0" strokeWidth="1"/>
    <rect x="316" y="100" width="50" height="6" rx="3" fill="#0064E0" opacity="0.3"/>
    <rect x="316" y="116" width="72" height="16" rx="4" fill="#0064E0" opacity="0.7"/>
    <rect x="316" y="145" width="40" height="6" rx="3" fill="#475569" opacity="0.2"/>
    <rect x="316" y="158" width="60" height="6" rx="3" fill="#22c55e" opacity="0.5"/>
    {/* Side mini chart */}
    <rect x="300" y="200" width="120" height="80" rx="12" fill="white" stroke="#E2E8F0" strokeWidth="1"/>
    <path d="M320 255 L340 240 L360 248 L380 225 L400 230" stroke="#0064E0" strokeWidth="2" strokeLinecap="round" fill="none"/>
    <path d="M320 255 L340 240 L360 248 L380 225 L400 230 L400 260 L320 260 Z" fill="#0064E0" opacity="0.06"/>
  </svg>
);
